import { useEffect, useState } from 'react';
import throttle from 'lodash.throttle';

let previousYPosition = window.pageYOffset;
let previousScrollDirection = 'DOWN';

const getPosition = () => {
  const y = window.pageYOffset;
  const scrollDirection = y > previousYPosition && y > 0 ? 'DOWN' : 'UP';
  return {
    y,
    scrollDirection,
    previousScrollDirection,
  };
};

const handleScroll = setPosition => throttle(() => {
  const newPosition = getPosition();
  previousYPosition = newPosition.y;
  previousScrollDirection = newPosition.scrollDirection;
  setPosition(newPosition);
}, 300);

const useScrollDirection = () => {
  const [position, setPosition] = useState(getPosition());

  useEffect(() => {
    const handleScrollFunc = handleScroll(setPosition);
    window.addEventListener('scroll', handleScrollFunc, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScrollFunc);
      handleScrollFunc.cancel();
    };
  }, []);

  return position;
};

export default useScrollDirection;
